import { CircularProgress, Fade, CardContent } from "@mui/material"
import "./styles.scss"

function Loading() {
  return <Fade in className="components_material-loading">
    <CardContent>
      <CircularProgress />
    </CardContent>
  </Fade>
}

export default Loading
